<template>
  <v-text-field
    v-model='search'
    prepend-icon='mdi-magnify'
    label='Invoice search'
    :hint='searchStatus'
    persistent-hint
    :loading='searching'
    :disabled='disable'
    single-line
    dense
  >
    <template v-slot:append-outer>
      <v-tooltip top>
        <template v-slot:activator='{ on }'>
          <v-btn
            v-on='on'
            small
            icon
            :color="unpaidOnly ? 'success' : ''"
            @click='unpaidOnly = !unpaidOnly'
          >
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>
          {{ tooltipText }}
        </span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script>
import accountingAPI from '@/api/accounting';
import _ from 'lodash';

export default {
  name: 'invoice-lookup',
  props: {
    disable: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    searching: false,
    search: '',
    searchStatus: '',
    unpaidOnly: true
  }),
  watch: {
    'search' () {
      const length = this.search.trim().length
      if (length > 2) {
        this.executeSearch()
      } else if (length > 0) {
        const remaining = 3 - length
        this.searchStatus = `Type ${remaining} more letter${remaining > 1 ? 's' : ''} to search`
        this.executeSearch(true)
      } else {
        this.searchStatus = ''
        this.$emit('newResults', [])
      }
    }
  },
  computed: {
    tooltipText () {
      return this.unpaidOnly ? 'Only searching unpaid' : 'Searcing all invoices'
    }
  },
  methods: {
    executeSearch: _.debounce(function (exact) {
      this.searching = true
      if (!exact) {
        this.searchStatus = `Searching for "${this.search.trim()}"...`
      }
      this.searchAPI(exact)
    }, 300),
    async searchAPI (exact) {
      let results = []
      if (this.search === '') {
        this.$emit('newResults', [])
      } else {
        if (this.unpaidOnly) {
          results = await accountingAPI.invoiceLookup(this.search.trim(), true, exact);
        } else {
          results = await accountingAPI.invoiceLookup(this.search.trim(), false, exact);
        }
        this.$emit('newResults', results);
      }
      if (!exact) {
        this.searchStatus = (results.length === 0 && this.search !== '') ? `No invoices found for "${this.search.trim()}"` : ''
      }
      this.searching = false
    },
    clearSearch () {
      this.search = ''
    }
  }
}
</script>
